module.exports = __webpack_public_path__ + "files/5e28b7854d9cabdb45b47c9218123e2b.png";